import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React from 'react';
import { MDXProvider } from '@mdx-js/react';
import { ColorModeProvider } from '@xstyled/styled-components';
import { ThemeProvider } from './ThemeProvider';
import { GlobalStyle } from './GlobalStyle';
import { Code } from './Code';
var components = {
  code: function code(_ref) {
    var children = _ref.children,
        className = _ref.className,
        props = _objectWithoutPropertiesLoose(_ref, ["children", "className"]);

    var lang = className && className.split('-')[1];
    return /*#__PURE__*/React.createElement(Code, Object.assign({
      lang: lang
    }, props), children);
  }
};
export function RootWrapper(_ref2) {
  var children = _ref2.children,
      theme = _ref2.theme;
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/React.createElement(ColorModeProvider, null, /*#__PURE__*/React.createElement(GlobalStyle, null), /*#__PURE__*/React.createElement(MDXProvider, {
    components: components
  }, children)));
}